//@ts-ignore
import { tw } from "@careinfo/tailwind";
import { useForm } from "react-hook-form";
import makeAnimated from "react-select/animated";
import Select from "react-select";

const animatedComponents = makeAnimated();

const ChangeStatus = (props: any) => {
  const { gridData, handleStatusChange } = props;
  return (
    <div className={tw`w-1/4`}>
      <span className={tw`text-primary font-semibold`}>Choose Next Status</span>
      <Select
        components={animatedComponents}
        closeMenuOnSelect={true}
        options={gridData}
        onChange={handleStatusChange}
        isMulti
      />
    </div>
  );
};

export default ChangeStatus;
